import { useValidateListOrder } from '../../filter';
import { useFileListOrder } from './useFileListOrder';
import { useSetFileListOrder } from './useSetFileListOrder';

export const useValidateFileListOrder = () => {
  return useValidateListOrder(useFileListOrder, useSetFileListOrder);
};
